// eslint-disable-next-line import/no-anonymous-default-export
export default {
  SET_NOTIFICATION: "SET_NOTIFICATION",
  CLEAR_NOTIFICATION: "CLEAR_NOTIFICATION",
  SET_NOTIFICATION_SUCCESS: "SET_NOTIFICATION_SUCCESS"
};
